import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserInformation } from '../model/user-information.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private httpClient = inject(HttpClient);
  // The user information does not change during a session and several callers
  // need it (app shell, route guards), so the request is made once and shared
  private userInformation$?: Observable<UserInformation>;

  public getUserInformation(): Observable<UserInformation> {
    if (!this.userInformation$) {
      this.userInformation$ = this.httpClient.get<any>(
        `${environment.apiUrl}/api/user`,
      ).pipe(
        map((response: any): UserInformation => UserInformation.createFromApi(response)),
        shareReplay({bufferSize: 1, refCount: false}),
      );
    }
    return this.userInformation$;
  }
}
